export default __webpack_public_path__ + "static/media/deleteDefault.90531b25.svg";